import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { walletRecovery } from '#src/contexts/currentUser/queries.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  ActivateWalletRecoveryEmailMutation,
  ActivateWalletRecoveryEmailMutationVariables,
} from './__generated__/useActivateWalletRecoveryEmail.graphql.ts';

const ACTIVATE_WALLET_RECOVERY_EMAIL = gql`
  mutation ActivateWalletRecoveryEmailMutation(
    $input: activateWalletRecoveryInput!
  ) {
    activateWalletRecovery(input: $input) {
      currentUser {
        slug
        ...CurrentUserProvider_walletRecovery
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${walletRecovery}
` as TypedDocumentNode<
  ActivateWalletRecoveryEmailMutation,
  ActivateWalletRecoveryEmailMutationVariables
>;

export const useActivateWalletRecoveryEmail = () => {
  const [mutate, { loading }] = useMutation(ACTIVATE_WALLET_RECOVERY_EMAIL, {
    showErrorsInForm: true,
  });

  const activateWalletRecoveryEmail = useCallback(
    async ({
      verificationCode,
      recoveryOptionId,
    }: {
      verificationCode: string;
      recoveryOptionId: string;
    }) => {
      const input = {
        verificationCode,
        recoveryOptionId,
      };
      const result = await mutate({
        variables: {
          input,
        },
      });
      return result;
    },
    [mutate]
  );

  return {
    activateWalletRecoveryEmail,
    loading,
  };
};
